
<div v-if="row.item.flags_count > 0" class="detailsButton clickable" @click.stop="callback(row)">
    <div class="row justify-content-center align-items-middle">
        <div class="col col-12">
            <div class="badge badge-pill badge-danger">{{ row.item.flags_count }}</div>
        </div>
        <div class="col col-12 text-center">
            <AnimatedCaret :expanded="row.detailsShowing" />
        </div>
    </div>
</div>
